/** Sample Allocation (user, 2026-10-14): the plant's SRFs and their tests to give out. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { AllocationListPage } from "@/features/quality/components/allocation/allocation-list-page";

const search = z.object({
  // "to_allocate" was the first list's default tab: an old link lands on the desk.
  view: z
    .enum(["desk", "all", "to_allocate"])
    .default("desk")
    .catch("desk")
    .transform((v) => (v === "to_allocate" ? "desk" : v)),
  q: z.string().optional(),
  page: z.number().int().min(1).default(1).catch(1),
});

export const Route = createFileRoute("/_app/quality/allocation/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.allocate")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AllocationListPage
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
